export default {
  home_search_for_product: "Vyhledejte svůj produkt",
  conventional_alternative: "Konvenční alternativa",
  led_alternative: "LED alternativa",
  search_filters_filter: "Filtr",
  search_submit: "Vyhledat produkt",
  results: "Výsledky",
  selected_product: "Vybraný produkt",
  search_input: "Zadejte kód (jeho část) či popis produktu",
  what_type_are_you_looking_for: "Jaký typ náhrady produktu hledáte?",
  recommendations_singular: "Doporučení",
  recommendations_plural: "Doporučení",
  your_product: "Váš produkt",
  search_filters_reset: "Zrušit filtry",
  results_specify: "Našli jsme více než 10 výsledků, upřesněte prosím své vyhledávání.",
  energy_efficient: "Energeticky účinné",
  active_filters: "Aktivní filtry",
  card_action: "Katalog",
  card_show_more: "Ukázat více",
  card_show_less: "Ukázat méně",
  card_alternative_fit: "Nejlepší Philips alternativa",
  card_perfect_fit: "Philips Best Fit alternativa",
  no_results_found: "Nebyly nalezeny žádné výsledky. Zkuste to znovu.",
  results_no_recommendations: "Nevíte si rady? Obraťte se na svého obchodního zástupce a najděte řešení společně.",
  search_filter_product_type: "Typ produktu",
  lighting_type: "Typ světelného zdroje",
  ean: "EAN",
  product_code: "Kód produktu",
  eoc: "EOC",
  family: "Produktová řada",
  discrete_wattage: "Příkon",
  wattage: "Příkon",
  brand: "Značka",
  driver_type: "Typ ovladače",
  number_of_lamps: "Počet svítidel",
  length: "Délka",
  color: "Barva",
  base: "Patice",
  local_eoc: "Lokální kód",
  ignitor: "Zapalovač",
  height: "Výška",
  width: "Šířka",
  mounting_hole: "Montážní otvor",
  mains_voltage: "Síťové napětí",
  thermal_protection: "Tepelná ochrana",
  delta_temperature: "Delta teploty",
  energy_efficiency: "Energetická účinnost",
  losses: "Ztráty energie",
  lamp_current: "Proud žárovky",
  pf_cap: "PF uzávěr",
  lumen: "Světelný tok",
  energy_saving: "Úspora energie",
  led_no_recommendations: "Pro tento produkt neexistují žádné alternativy LED.",
  
  /*loading: "Načítání...",
  too_many_requests: "Vaše vyhledávání je omezeno. Chcete-li toto omezení obejít, zaregistrujte si účet nebo to zkuste znovu později.",
  session_expired: "Vaše relace vypršela. Přihlaste se prosím znovu.",
  header_sign_out: "Odhlásit se",
  header_login: "Přihlásit se",
  header_help: "Pomoc",
  welcome_header: "Vítejte ve Philips konverzním nástroji",
  welcome_copy: "S konverzním nástrojem Philips je velmi snadné najít Philips alternativy konvenčních zdrojů a předřadníků.",
  welcome_feature_1: "Snadno najděte své produkty",
  welcome_feature_2: "Snadné vyhledávání a výsledky",
  welcome_feature_3: "Získejte všechny informace a specifikace potřebné k převodu produktu",
  login_title: "Přihlásit se",
  login_form_username: "Uživatelské jméno",
  login_form_password: "Heslo",
  login_form_remember: "Zůstat přihlášen",
  login_form_forgot_pswd: "Zapomněli jste heslo?",
  login_form_login: "Přihlásit se",
  login_no_account_yet: "Nemáte ještě účet?",
  login_request_account: "Požádejte o účet",
  login_skip_request_explanation: "Při přeskočení přihlášení můžete najít produkty, ale s velmi omezeným výstupem. Nejsou k dispozici žádné technické podrobnosti, porovnání specifikace, vícenásobné vstupy / výstupy ani export. Chcete-li získat plnou podporu, vytvořte si účet a uložte si heslo pro snadný přístup.",
  login_skip_login_cta: "Přeskočit přihlášení",
  login_credentials_invalid: "E-mail nebo heslo nesprávné",
  login_forgot_pswd: "Zapomenuté heslo",
  login_forgot_pswd_content_one: "Zapomněli jste heslo? To je v pořádku - Zadejte e-mailovou adresu spojenou s vaším účtem nástroje pro převod.",
  login_forgot_pswd_content_two: "Pokud jste v našem systému, pošleme vám odkaz na resetování.",
  login_forgot_pswd_email: "Emailová adresa",
  login_forgot_request_pswd: "Požádejte o nové heslo",
  login_forgot_invalid: "Nesprávná e-mailová adresa",
  login_successful: "Úspěšně přihlášeno",
  logout_successful: "Odhlášení bylo úspěšně odhlášeno",
  home_search_for_product: "Vyhledejte svůj produkt",
  home_title: "Jak to funguje",
  home_subtitle: "Je to vlastně opravdu snadné.",
  home_content_one: "Navrhli jsme vyhledávací lištu pro rychlost a rychlé výsledky.",
  home_content_two: "Chcete-li získat návrh hledaného produktu, zadejte (část) kód nebo popis produktu. Pokud tyto informace nemáte, použijte filtry a vyhledejte požadovaný produkt.",
  home_content_three: "Jakmile vyberete produkt, můžete zkontrolovat všechny informace potřebné k převodu. Až budete hotovi, můžete výsledky exportovat nebo vyhledat další produkt.",
  home_contact_us: "Kontaktujte nás",
  request_account_title: "Požádejte o účet",
  request_account_content_one: "S účtem máte plný přístup k našemu online konverznímu nástroji, včetně všech funkcí vícenásobného vstupu, exportu, porovnání specifikací a neomezeného vyhledávání.",
  request_account_content_two: "K ověření vašeho účtu potřebujeme několik základních informací o účtu a společnosti.",
  request_account_content_three: "Po ověření obdržíte oficiální odkaz na vytvoření účtu.",
  request_account_personal_information: "Osobní informace",
  request_account_first_name: "Jméno",
  request_account_last_name: "Příjmení",
  request_account_email: "Emailová adresa",
  request_account_username: "(Toto bude vaše uživatelské jméno)",
  request_account_password_1: "Heslo",
  request_account_password_2: "Zopakovat heslo",
  request_account_company: "Společnost",
  request_account_company_name: "Jméno společnosti",
  request_account_country: "Země",
  request_account_job: "Pracovní pozice",
  agree_to_privacy_policy: "Přečetl jsem a souhlasím se zásadami ochrany osobních údajů a podmínkami použití",
  validate_all_fields_required: "Všechna pole jsou povinná.",
  validate_agree_tac: "Musíte souhlasit s našimi smluvními podmínkami",
  validate_passwords_dont_match: "Hesla se neshodují.",
  validate_password_too_short: "Heslo by mělo mít alespoň 8 znaků.",
  validate_password_too_weak: "Vaše heslo není dostatečně silné.",
  email_already_in_use: "Uživatel je již zaregistrován s touto e-mailovou adresou.",
  email_verify_in_progress: "Ověření vaší e-mailové adresy...",
  email_verified_success: "Vaše e-mailová adresa byla úspěšně ověřena. Nyní se můžete přihlásit.",
  email_verified_failed: "Je nám líto, ale vaši e-mailovou adresu jsme nemohli ověřit.",
  registration_successful: "Na vaši e-mailovou adresu byl zaslán ověřovací e-mail.",
  password_reset_failed: "Došlo k chybě, zkuste to znovu později",
  password_reset_email_sent: "Poslali jsme vám e-mail s odkazem na nastavení nového hesla.",
  new_password_header: "Vyberte nové heslo",
  new_password: "Nové heslo",
  repeat_new_password: "Zopakujte své nové heslo",
  save_new_password: "Uložte nové heslo",
  password_changed_success: "Heslo bylo úspěšně změněno.",
  request_account_request: "Požádat o účet",
  visual_input_code_title: "Zadejte kód / popis produktu",
  visual_input_code_content: "Zadejte název produktu, kód nebo hledejte pomocí filtrů.",
  visual_hit_search_title: "Stiskněte tlačítko Hledat",
  visual_hit_search_content: "Jste připraveni? Klepnutím na toto vyhledávací tlačítko získáte výsledky",
  visual_select_result_title: "V poli návrhů vyberte svůj výsledek",
  visual_select_result_content: "Přejděte dolů a podívejte se na nabízenou Philips alternativu a získejte všechny potřebné informace.",
  search_input: "Zadejte (část) kód nebo popis produktu",
  search_submit: "Vyhledat produkt",
  search_filter_product_type: "Typ produktu",
  search_filter_device: "Zařízení",
  search_filter_color: "Barva",
  search_filter_wattage: "Příkon",
  search_filter_brand: "Značka",
  search_filter_show_all: "Zobrazit všechny filtry",
  search_filter_hide_all: "Skrýt všechny filtry",
  search_filter_clear_all: "Vymazat filtry",
  results_export: "Exportovat výsledky",
  result_export_all: "Exportovat všechny výsledky",
  results: "Výsledeky",
  results_shown: "Výsledek",
  no_results_found: "Nebyly nalezeny žádné výsledky. Zkuste prosím jiný vyhledávací dotaz",
  results_no_recommendations: "Zasekli jste se? Chcete-li najít řešení, obraťte se na místního správce účtu nebo obchodního zástupce",
  recommendations_singular: "Doporučení",
  recommendations_plural: "Doporučení",

  home_contact_us_content: "Should you require any further information or if you have any questions, feel free to contact us and we will be glad to assist you.",
  home_contact_us_first_name: "Jméno",
  home_contact_us_last_name: "Příjmení",
  home_contact_us_email: "Emailová adresa",
  home_contact_us_message: "Message",
  home_contact_us_submit: "Submit",
  home_contact_us_successfully: "Your message is successfully sent.",
  home_contact_us_error: "Something went wrong, please try again.",
  usage_disclaimer: "Intended only for the use of qualified Philips customers.",
  search_filter_bulb_finish: "Bulb finish",
  search_filter_bulb: "Bulb",
  search_filter_ignitor: "Ignitor",
  search_filter_packaging_configuration: "Packaging configuration",
  search_filter_fixture_feature: "Fixture feature",
  search_filter_base: "base",
  total_number_results: "Total number of results",
  results_specify: "There are more than 10 results, please further specify your search",

  //facets
  brand: "Značka",
  wattage: "Příkon",
  type: "Type",
  color: "Barva",
  bulb_finish: "Bulb finish",
  subfamily: "Subfamily",
  bulb: "Bulb",
  ignitor: "Ignitor",
  packaging_configuration: "Packaging configuration",
  fixture_feature: "Fixture feature",
  family: "Family",
  base: "Base",
  pf_cap: "PF cap",
  number_of_lamps: "Number of lamps",
  lamp_current: "Lamp current",
  mains_frequency: "Mains frequency",
  driver_type: "Driver type",
  mains_voltage: "Mains voltage",
  height: "Height",
  weight: "Weight",
  thermal_protection: "Thermal protection",
  losses: "Losses",
  temp_range: "Temperature range",
  delta_temperature: "Delta temperature",
  life_class_tw: "Life class TW",
  wiring_diagram: "Wiring diagram",
  width: "Width",
  length: "Length",
  type_of_lamp: "Type of lamp",
  mounting_hole: "Mounting hole",
  power_factor: "Power factory",
  energy_efficiency: "Energy efficiency",
  product_description: "Product description",


  //Match and result props
  apr: "APR",
  ean: "EAN",
  eu: "EU",
  latam: "Latam",
  material_description: "Material description",
  nam: "NAM",
  // product_code: "12NC",
  product_code: "Product code",
  remark: "Remark",
  valid: "Valid",

  card_action: "Catalogue",
  card_perfect_fit: "Philips Best Fit",
  card_alternative_fit: "Philips Best Alternative",
  card_show_more: "Show more",
  card_show_less: "Show less"*/
};
